import * as yup from 'yup';

export const autoModeValidation = yup.object().shape({
	advertisementId: yup
		.number()
		.required('Advertisement is a mandatory field')
		.min(1, 'Advertisement is a mandatory field'),
	budget: yup.number().required().min(1, 'Budget should be greater than 0'),
	noOfTimes: yup.number().required().min(1, 'No of times shoud be greater >= 1'),
	areas: yup.array().min(1, 'Atleast one area should be selected.'),
});

export const manualModeValidation = yup.object().shape({
	advertisementId: yup
		.number()
		.required('Advertisement is a mandatory field')
		.min(1, 'Advertisement is a mandatory field'),
	areas: yup.array().min(1, 'Atleast one area should be selected.'),
});

export const manualLocationGroupModeValidation = yup.object().shape({
	advertisementId: yup
		.number()
		.required('Advertisement is a mandatory field')
		.min(1, 'Advertisement is a mandatory field'),
	cities: yup.array().min(1, 'Atleast one city should be selected.'),
});
